module.exports = __webpack_public_path__ + "img/k_lagan_logo.d7c7d58b.jpg";